import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, createdByField, field, lastModifiedByField, lookup, type Row, text } from './kit';

const def = OBJECT_DEFS['user-resource-roles'];

/** A role a person can fill. Rationale: user-resource-roles.md. */
export const userResourceRoles: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Person role',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('app_user_name', 'Person', { link: lookup('people', 'app_user_id') }),
    field('resource_role_name', 'Role', { link: lookup('resource-roles', 'resource_role_id') }),
    field('is_primary', 'Primary Role', { format: asCheck }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['app_user_name', 'resource_role_name', 'is_primary'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'app_user_name', 'resource_role_name'],
};
